import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import LoaderSpinner from 'react-loader-spinner'
import "../scss/react-spinner-loader.css";

import Loader from 'src/utils/loader'

const TheLoader = () => {
  const dispatch = useDispatch();
  const loaderShow = useSelector(state => state.admin.loaderShow);

  useEffect(() => {
    Loader.setLoader(dispatch);
  }, []);

  return (
    <>
      {loaderShow && <>
        <div className='react-spinner-loader-background'></div>        
        <LoaderSpinner type="Bars" color="#23489c"  secondaryColor="#3096d2"  height={60} width={60} className='react-spinner-loader' />
      </>
      }
    </>
  )
}

export default React.memo(TheLoader)
